// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","map":"map-wrapper_map__g4J6h","mapContainer":"map-wrapper_mapContainer__E92RG"};